import { mergeStyles } from "@fluentui/merge-styles";

export const bracketedTextClass = mergeStyles({
  whiteSpace: "nowrap", // Prevent breaking inside brackets
});
